import React from 'react';
import { WhoWeAreAttributes } from '@app/models/dtos/strapi';
import ImageRenderer from '@app/components/media-renderer/image-renderer';
import environments from '@app/configs/environments';
import RadialGradient from '@app/components/ui/radial-gradient';

function WhoWeAreUi({ whoWeAre }: { whoWeAre: WhoWeAreAttributes }) {
    return (
        <div className="my-[60px] flex w-full flex-col items-center md:my-[160px]">
            <div className="container w-full">
                <p className="P2  !text-black-1 ">Who We Are</p>
                <p className="h2-responsive my-2 max-w-[903px] text-black-1 md:my-6" dangerouslySetInnerHTML={{ __html: whoWeAre.title }}></p>
                <p className="P1 max-w-[519px] text-black-2">{whoWeAre.description}</p>
            </div>

            {whoWeAre.featureImage && (
                <div className="mt-[30px] aspect-banner-mobile w-full overflow-hidden md:mt-[60px] lg:aspect-banner-desktop">
                    <ImageRenderer media={environments.STRAPI_HOST_URL + whoWeAre.featureImage.url} />
                </div>
            )}
        </div>
    );
}

export default WhoWeAreUi;
